export default "__VITE_ASSET__DK9IOTJe__"